export default [
  {
    path: '/admin/work-schedules',
    name: 'work-schedule',
    meta: { requiresAuth: true },
    component: () => import('@/pages/human-resource/work-schedule/index.vue')
  }
]
